import Vue from 'vue';
import { Progress } from 'vant';
const open = require('./pic/openthedoor.png')
const success = require('./pic/door_success.png')

export default {
  name: 'openDoor',
	data: () => ({
		pic: open,
		type: 0,
		percent: 0,
		success
	}),
	created () {
		setInterval(() => {
			if (this.percent >= 100) {
				this.type = 1
			}
			this.percent+= 2.5
		}, 40)
	},
  render() {
		const { pic, type, percent, success } = this
    return (
      <section style={styles.container}>
        {
					type == 0 ? 
					(
						<section>
							<img src={pic} style={styles.img} />
							<div style={styles.progress}>
								<span style="display: block; margin: 12px auto; text-align: center;">请靠近门禁</span>
								<van-progress percentage={percent} color="#0D80EF" track-color="#" stroke-width="8px" show-pivot={false} />
							</div>
						</section>
					)
					:
					(
						<section style="position: relative; width: 100%; height: 100%;">
							<div style={styles.center}>
								<span style="display: block; margin: 12px auto; text-align: center; font-size: 18px;"><i style={styles.icon}/>开门成功</span>
								<img style={styles.img} src={success} />
							</div>
						</section>
					)
				}
      </section>
    )
  }
}
const styles = {
  container: {
    width: '100%',
    height: '100%'
  },
  img: {
    width: '100%',
    height: '100%',
    display: 'block'
  },
	progress: {
		width: '60%',
		fontSize: '18px',
		color: '#333',
		margin: '-80px auto',
	},
	center: {
		position: 'absolute',
		top: '50%',
		transform: 'translateY(-50%)'
	},
	icon: {
		width: '30px',
		height: '30px',
		'margin-right': '10px',
		top: '8px',
		position: 'relative',
		display: 'inline-block',
		'background-image': 'url(data:image/png;base64,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)',
		'background-size': 'cover'
		
	}
}
